import * as React from 'react';
export const arrowRightSvg = React.forwardRef(function arrowRightSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.28.97a.75.75 0 0 0-1.06 1.06l3.22 3.22H.75a.75.75 0 0 0 0 1.5h8.69L6.22 9.97a.75.75 0 1 0 1.06 1.06l4.5-4.5a.747.747 0 0 0 0-1.06L7.28.97Z',
    }),
  );
});
arrowRightSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var arrowRight = {
  category: 'icon',
  colorable: true,
  name: 'arrowRight',
  svg: arrowRightSvg,
};
